import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=14000ce2&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14000ce2')) {
      api.createRecord('14000ce2', component.options)
    } else {
      api.reload('14000ce2', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=14000ce2&", function () {
      api.rerender('14000ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorMessage.vue"
export default component.exports